import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';

interface MosaicGridBoneProps {
    /** Nombre de colonnes */
    columns?: number;
    /** Nombre de lignes */
    rows?: number;
    /** Hauteur des cartes */
    cardHeight?: string;
    /** Styles personnalisés du container */
    sx?: SxProps<Theme>;
    /** Styles personnalisés des items (surcharge les défauts) (ajouter "flex: undefined" pour éviter le fit-content par défaut) */
    sxItem?: SxProps<Theme>;
}

export const MosaicGridBone: React.FunctionComponent<MosaicGridBoneProps> = function ({
    columns = 3,
    rows = 3,
    cardHeight = '200px',
    sx = {},
    sxItem = {},
}) {
    const defaultItemSx: SxProps = {
        width: `${Math.round(80 / columns)}%`,
        height: cardHeight,
        flex: 1,
    };

    return (
        <Box
            sx={[
                {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    width: '100%',
                    height: '100%',
                    padding: '16px',
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <Box
                    key={`mosaic-row-${rows}-${rowIndex + 1}`}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        alignItems: 'flex-start',
                        gap: 3,
                        width: '100%',
                        height: '100%',
                    }}
                >
                    {Array.from({ length: columns }).map((__, colIndex) => (
                        <BoxBone
                            key={`mosaic-card-r${rowIndex + 1}-c${colIndex + 1}`}
                            sx={{
                                ...defaultItemSx,
                                ...sxItem,
                            }}
                        />
                    ))}
                </Box>
            ))}
        </Box>
    );
};
